import { render, staticRenderFns } from "./TextInputInternal.vue?vue&type=template&id=537711c4"
import script from "./TextInputInternal.vue?vue&type=script&lang=js"
export * from "./TextInputInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports